import {useState} from "react";
import {Button} from "@mui/material";
import * as React from "react";

export default function CampaignsShowAddCampaignNumbers({row,addVouchers,btnAddDisabled,voucherMessage}) {

    const [numberVoucher, setNumberVouchers] = useState('');

    return (
        <>
            <div style={{display:'flex',gap:5}}>
                <input className={"form-control"}
                       style={{
                           marginBottom:5,flexGrow:0,flexShrink:0, width:100,
                           color: ((String(numberVoucher).replace(/\D/g,'') !== numberVoucher) || numberVoucher > 1000) ? 'red' : null,
                           borderColor: ((String(numberVoucher).replace(/\D/g,'') !== numberVoucher) || numberVoucher > 1000) ? 'red' : null
                       }}
                       value={numberVoucher}
                       onChange={(e) => setNumberVouchers(e.target.value)}
                />
                <Button style={{marginBottom:5,flexGrow:1,flexShrink:0}}
                        disabled={String(numberVoucher) === '' || btnAddDisabled || (String(numberVoucher).replace(/\D/g,'') !== numberVoucher) || numberVoucher > 1000}
                        variant={"contained"} size={"small"} onClick={() => addVouchers(numberVoucher)}
                >Add vouchers</Button>
            </div>
            <small style={{fontSize:'0.7em',color:'gray'}}>A maximum of 1000 vouchers applies.</small>
            {
                (voucherMessage && voucherMessage[row.id]) ?
                    <small style={{fontSize:'0.6em', color:'red'}} dangerouslySetInnerHTML={{__html:voucherMessage[row.id]}}></small>
                    : null
            }
        </>
    )
}
